import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {defaultDesignBlockData} from "../../../base-design-block-modal/configs/default-design-block-data";
import {DesignBlockData} from "../../../base-design-block-modal/types/base-design-block.types";
import {AttachFileParams, EntityFileType} from "../../../../../../../../core/types/file.types";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {
  BaseDesignBlockPathStateService
} from "../../../base-design-block-modal/services/base-design-block-path-state.service";
import {DesignBlockFilesService} from "../../services/design-block-files.service";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {FormsModule} from "@angular/forms";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-db-bottom-modal]',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    FormsModule,
    FileUploadCardComponent
  ],
  templateUrl: './db-bottom-modal.component.html',
  styleUrl: './db-bottom-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DbBottomModalComponent {
  designBlockData = input<DesignBlockData>(defaultDesignBlockData);
  isEditModeActive = input<boolean>(false);
  isActiveUploadFile = input<boolean>(false);
  designBlockEntityFileType = input<EntityFileType>('LISTING');
  updateComment = output<DesignBlockData>();
  attachFile = output<AttachFileParams>();

  private baseDesignBlockPathStateService: BaseDesignBlockPathStateService = inject(BaseDesignBlockPathStateService);
  private designBlockFilesService: DesignBlockFilesService = inject(DesignBlockFilesService);

  public async handleUpdateComment(): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.baseDesignBlockPathStateService.pathState(),
      recordId: this.designBlockData().id,
      fieldName: 'comment',
      value: this.designBlockData().comment
    };

    const updateData = await this.designBlockFilesService.updatedRecordField<DesignBlockData>(params).catch(() => this.designBlockData());
    this.updateComment.emit(updateData);
  }

  public handleAttachFile(attachFileParams: AttachFileParams): void {
    this.attachFile.emit(attachFileParams);
  }
}
